import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import PageTitle from "../../components/PageTitle";
import { Skeleton } from "../../components/ui/Skeleton";
import { Alert, AlertTitle, AlertDescription } from "../../components/ui/Alert";
import { Badge } from "../../components/ui/Badge";
import { Card } from "../../components/ui/Card";
import ActionPayment from "./ActionPayment";

const TuitionFees = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["myTuitionHistory"],
    queryFn: async () => {
      const req = await axiosget(`ms_transactions`);
      return req?.data;
    },
  });

  return (
    <div className="min-h-screen">
      <PageTitle
        title="TUITION PORTAL"
        sub="Your Payment History & Academic Status"
      />

      {isLoading && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-5">
          {[...Array(3)].map((_, i) => <Skeleton key={i} className="h-[400px] rounded-2xl" />)}
        </div>
      )}
      {error && <Alert variant="danger"><AlertTitle>Error</AlertTitle><AlertDescription>Local server error: {error.message}</AlertDescription></Alert>}
      {data?.type !== undefined && <Alert variant="danger"><AlertTitle>Error</AlertTitle><AlertDescription>{data?.message}</AlertDescription></Alert>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-5">
        {data &&
          data?.type === undefined &&
          data?.map((v, i) => (
            <Card
              key={`payment_card_${i}`}
              padding="none"
              className={`flex flex-col min-h-[400px] border-l-[6px] ${v?.isActive ? 'border-l-success-500' : 'border-l-danger-500'} hover:-translate-y-1 transition-transform`}
            >
              {/* Header */}
              <div className="px-4 pt-4 pb-2 flex justify-between items-start">
                <div className="w-10 h-10 bg-neutral-50 rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-neutral-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0v7" />
                  </svg>
                </div>
                <Badge variant={v?.isActive ? "success" : "default"} size="sm">
                  {v?.isActive ? "Active" : "Inactive"}
                </Badge>
              </div>

              {/* Body */}
              <div className="px-4 pb-4 flex-grow">
                <div className="mb-3">
                  <h4 className="text-lg font-extrabold text-neutral-900 mb-1">
                    {v?.programme?.name || "Program Information"}
                  </h4>
                  <p className="text-xs text-neutral-400 font-semibold">
                    CODE: {v?.programme?.code || "N/A"}
                  </p>
                </div>

                {[
                  { label: "Level", value: `${v?.level} Level` },
                  { label: "Semester", value: v?.semester },
                  { label: "Admission", value: v?.isAdmitted ? "Admitted" : "Pending", isAdmitted: v?.isAdmitted },
                  { label: "Step", value: v?.step },
                ].map((row, idx) => (
                  <div key={idx} className="flex justify-between py-3 border-b border-neutral-100 last:border-0">
                    <span className="text-sm text-neutral-500 font-medium uppercase tracking-wide">{row.label}</span>
                    <span className="text-sm text-neutral-800 font-bold flex items-center gap-1.5">
                      {row.isAdmitted && <svg className="w-4 h-4 text-success-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>}
                      {row.value}
                    </span>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className="px-4 py-3 bg-neutral-50">
                <ActionPayment v={v} />
              </div>
            </Card>
          ))}
      </div>
    </div>
  );
};

export default TuitionFees;
